import { useMemo } from 'react';

interface IProps {
  fontSize: number;
  onFontSizeChange: (value: number) => void;
}

export const PDFTextmarkSizePicker = (props: IProps) => {
  const { fontSize, onFontSizeChange } = props;

  const sizes = useMemo(() => {
    const start = 1;
    const end = 100;
    const result = [];
    for (let i = start; i <= end; i++) {
      result.push(i);
    }
    return result;
  }, []);

  return (
    <select
      style={{ height: '1.75rem' }}
      value={fontSize}
      onChange={(e) => onFontSizeChange?.(Number(e.target.value))}
    >
      {sizes.map((size) => {
        return <option value={size}>{size}pt</option>;
      })}
    </select>
  );
};
